import { toHouseRuleAnswers as e } from "../../houseRules/houseRuleAnswers.mjs";
import { RentalTypeEnum as t } from "@maat/api-main/types";
//#region src/properties/createProperty/buildHotelCreatePayload.ts
var n = (e, t) => {
	let n = e.name.trim(), r = e.roomCount >= 2;
	return {
		name: n,
		unitType: e.unitType,
		guests: e.guests,
		bedrooms: e.bedrooms,
		beds: e.beds,
		bathrooms: e.bathrooms,
		amenityIds: [...e.amenityIds],
		...t,
		...r ? { rooms: { names: e.roomNames.slice(0, e.roomCount).map((e) => e.trim()) } } : {},
		listing: {
			title: n,
			basePrice: e.basePrice,
			currency: e.currency,
			isExclusive: e.isExclusive ?? !1,
			isBestPrice: e.isBestPrice ?? !1,
			instantBooking: e.instantBooking ?? !1
		}
	};
}, r = (r, i = []) => {
	let a = {
		houseRules: r.houseRuleIds === null ? [] : e(i, r.houseRuleIds),
		...r.checkInTime ? { checkInTime: r.checkInTime } : {},
		...r.checkOutTime ? { checkOutTime: r.checkOutTime } : {}
	}, o = r.description?.trim();
	return {
		propertyType: r.propertyType,
		rentalType: t.IndividualListings,
		location: {
			lat: r.location.lat,
			lng: r.location.lng,
			address: r.location.address
		},
		address: r.address,
		name: r.name.trim(),
		...o ? { description: o } : {},
		amenityIds: [...r.facilityIds],
		units: r.roomTypes.map((e) => n(e, a))
	};
};
//#endregion
export { r as buildHotelCreatePayload };
